export default __webpack_public_path__ + "images/a9827e1e1f7891829b873cfbdd8a40b9.svg";